import { Check as CheckIcon, X as XIcon } from "@tamagui/lucide-icons";
import { Paragraph2, Spinner, YStack } from "@medbillai/ui";
import { assertNever } from "@medbillai/utils";
type LinkingProgressStatus = "loading" | "success" | "failure";
export type StatusIndicatorProps = {
  state: LinkingProgressStatus;
  statusText?: string;
};
const IndicatorIcon = ({
  state
}: {
  state: LinkingProgressStatus;
}) => {
  switch (state) {
    case "failure":
      return <XIcon />;
    case "loading":
      return <Spinner size="small" color="$color13" />;
    case "success":
      return <CheckIcon />;
    default:
      return assertNever(state, "Invalid linking progress state value");
  }
};
export const StatusIndicator = ({
  state,
  statusText
}: StatusIndicatorProps) => {
  return <YStack alignItems="center" gap="$4" data-sentry-element="YStack" data-sentry-component="StatusIndicator" data-sentry-source-file="StatusIndicator.tsx">
      <YStack backgroundColor="$cream7" borderRadius={100} width={72} height={72} alignItems="center" justifyContent="center" data-sentry-element="YStack" data-sentry-source-file="StatusIndicator.tsx">
        <IndicatorIcon state={state} data-sentry-element="IndicatorIcon" data-sentry-source-file="StatusIndicator.tsx" />
      </YStack>

      {statusText ? <Paragraph2 textAlign="center">{statusText}</Paragraph2> : null}
    </YStack>;
};